import { APIModel } from "./api-model";

export class Status extends APIModel {
  name: string;

  static fieldsToMap = {
    directNA: [
      'name'
    ]
  }

  static buildFromAPI(record: any): Status {
    const row = new Status();
    record = record || {};

    this.mapFieldsNA<Status>(Status.fieldsToMap.directNA, record, row);

    return row;
  }
}